//IE11 swiper js 'startsWith' Polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position){
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
};
}
var swiper = new Swiper('.swiper-celeb-fans', {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  // init: false,
  autoplay: {
    delay: 7500,
  },
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next.swiper-hero',
    prevEl: '.swiper-button-prev.swiper-hero',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }
});
var swiper = new Swiper('.swiper-spa', {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  loopAdditionalSlides: 1,
  // init: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next.swiper-mod-1',
    prevEl: '.swiper-button-prev.swiper-mod-1',
  },
  breakpoints: {       
    960: {
      slidesPerView: 1.1,
      spaceBetween: 1,
    }
  }
});
var swiper = new Swiper('.swiper-little-fans', {
  slidesPerView: 2.3,
  spaceBetween: 10,
  loop: false,
  // init: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next.swiper-little-fans-nav',
    prevEl: '.swiper-button-prev.swiper-little-fans-nav',
  },
  breakpoints: {       
    600: {
      slidesPerView: 2,
      spaceBetween: 1,
    }
  }
});
var swiper = new Swiper('.swiper-bedding', {
  slidesPerView: 2.3,
  spaceBetween: 10,
  loop: false,
  // init: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next.swiper-bedding-nav',
    prevEl: '.swiper-button-prev.swiper-bedding-nav',
  },
  breakpoints: {       
    600: {
      slidesPerView: 2,
      spaceBetween: 1,
    }
  }
});
var swiper = new Swiper('.swiper-bath-body', {
  slidesPerView: 2.3,
  spaceBetween: 10,
  loop: false,
  // init: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next.swiper-bath-body-nav',
    prevEl: '.swiper-button-prev.swiper-bath-body-nav',
  },
  breakpoints: {       
    600: {
      slidesPerView: 2,
      spaceBetween: 1,
    }
  }
});
var swiper = new Swiper('.swiper-fragrance', {
  slidesPerView: 2.3,
  spaceBetween: 10,
  loop: false,
  // init: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next.swiper-fragrance-nav',
    prevEl: '.swiper-button-prev.swiper-fragrance-nav',
  },
  breakpoints: {       
    600: {
      slidesPerView: 1,
      spaceBetween: 1,
    }
  }
});
var swiper2 = new Swiper('.swiper-hotel-exclusives', {
  slidesPerView: 1,
  spaceBetween: 1,
  loop: false,
  // init: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }
});

var swiper3 = new Swiper('.item-image .swiper-container', {
  slidesPerView: 1,
  spaceBetween: 0,
  watchOverflow:true,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

const buttonTl = gsap.timeline();
let isReversed = false;
const pagination = Array.from(document.querySelectorAll('.swiper-pagination'))
var sleepfulnessSwiper = new Swiper(".sleepfulness-swiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: pagination,
      clickable: true
    },
    parallax: true,
    a11y: {
        enabled: true,
        slideLabelMessage: ""
      },
    // -----unrelated settings end -----
    speed: 1500,
    watchSlidesProgress: true,
  });